<template>
  <div class="modal-wrapper" :class="{ 'show': isOpen }">
    <div class="modal-overlay" @click="handleClose"></div>
    <div class="modal-sidebar shadow-lg">
      <div class="modal-header d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
        <h5 class="m-0 fw-bold text-primary">
          <i class="fa fa-edit me-2"></i>Chỉnh sửa đơn hàng
        </h5>
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-outline-secondary btn-sm" @click="handleClose">
            <i class="fa fa-times me-1"></i>Hủy bỏ
          </button>
          <button class="btn btn-primary btn-sm px-3" @click="submitForm" :disabled="submitting">
            <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
            <i v-else class="fa fa-save me-1"></i>Cập nhật
          </button>
        </div>
      </div>

      <div class="modal-body" v-if="isOpen && orderId">
        <OrderForm
          ref="formRef"
          :orderId="orderId"
          :hide-header="true"
          @save-success="handleSaveSuccess"
          @cancel="handleClose"
          @loading-change="submitting = $event"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import OrderForm from '../OrderForm.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  orderId: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(['close', 'save-success']);

const formRef = ref(null);
const submitting = ref(false);

// Reset submitting state khi đóng/mở modal
watch(() => props.isOpen, (val) => {
  if (!val) submitting.value = false;
});

const handleClose = () => {
  emit('close');
};

const handleSaveSuccess = () => {
  emit('save-success');
  emit('close');
};

// Trigger submit từ button trên modal header
const submitForm = () => {
  if (formRef.value) {
    formRef.value.handleSubmit();
  }
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
  visibility: hidden;
  transition: visibility 0.3s;
}

.modal-wrapper.show {
  visibility: visible;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.modal-wrapper.show .modal-overlay {
  opacity: 1;
}

.modal-sidebar {
  position: absolute;
  top: 0;
  right: -1100px;
  width: 1100px;
  max-width: 95%;
  height: 100%;
  background: #f8f9fa;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
}

.modal-wrapper.show .modal-sidebar {
  right: 0;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  font-size: 14.5px;
  padding: 0;
}

.gap-2 {
  gap: 0.5rem;
}

@media (max-width: 1100px) {
  .modal-sidebar {
    width: 100%;
    right: -100%;
  }
}
</style>
